export var Copied = "Copied to clipboard";
export var CopyLink = "Copy permalink";
export var ExpandGroup = "Expand group on line {0}";
export var LogSection = "Logs section";
export var SearchKeyword = "Type a keyword to search..";
export var SpinnerLabel = "Loading...";
